export const PHASE_COLOURS = {
  teal: { label: 'Teal', solid: '#12B89A', ink: '#0A5C4E' },
  blue: { label: 'Blue', solid: '#3B82F6', ink: '#1C4DAE' },
  rose: { label: 'Rose', solid: '#F0418C', ink: '#9A1B55' },
  amber: { label: 'Amber', solid: '#F2B019', ink: '#7A5300' },
  purple: { label: 'Purple', solid: '#8B5CF6', ink: '#5A2EC2' },
  orange: { label: 'Orange', solid: '#F97316', ink: '#963C06' },
  green: { label: 'Green', solid: '#22C55E', ink: '#13692F' },
  sky: { label: 'Sky', solid: '#0EA5E9', ink: '#075A82' },
  slate: { label: 'Slate', solid: '#64748B', ink: '#334155' },
  neutral: { label: 'Neutral', solid: '#A1A1AE', ink: '#4A4A57' }
};

export const COLOUR_KEYS = Object.keys(PHASE_COLOURS);

export const UNASSIGNED = { label: 'No phase', solid: '#B9BAC8', ink: '#5B5C70' };

export function phaseColour(key) {
  return PHASE_COLOURS[key] || PHASE_COLOURS.neutral;
}

export function nextColourKey(usedKeys = []) {
  const used = new Set(usedKeys);
  return COLOUR_KEYS.find((k) => !used.has(k) && k !== 'neutral') || COLOUR_KEYS[usedKeys.length % COLOUR_KEYS.length];
}

export const ROADMAP_COLOURS = ['#6B6CF7', '#12B89A', '#F0418C', '#F2A20C', '#0EA5E9', '#F97316', '#8B5CF6', '#22C55E'];

export function roadmapColour(index) {
  return ROADMAP_COLOURS[index % ROADMAP_COLOURS.length];
}

export function phaseVars(key) {
  const c = key === null ? UNASSIGNED : phaseColour(key);
  return { '--phase': c.solid, '--phase-ink': c.ink };
}
